module.exports = __webpack_public_path__ + "images/zekur_smalld8055927d293b5dfffc4635a3eaaff71.png";